import {leftPadWithZeros} from './leftPadWithZeros';

export const FORMAT_HHMMSS = 'hh:mm:ss';
export const FORMAT_MMSS = 'mm:ss';

/**
 * Formats a number of seconds into a time string with the specified pattern.
 * If no pattern is provided, defaults to hh:mm:ss
 *
 * @param totalSeconds the number of seconds to format into a string
 * @param format the time format to output (default: hh:mm:ss)
 * @return {string} the formatted time string
 */
export const secondsToTime = (
  totalSeconds: number,
  format: string = FORMAT_HHMMSS
): string => {
  const isNegative = totalSeconds < 0;

  if (isNegative) {
    // If the time is negative, we make it positive for the calculation below
    // (else we'd get all negative numbers) and reattach the negative sign later.
    totalSeconds *= -1;
  }

  // Split into seperate time parts
  const hours = Math.floor(totalSeconds / 3600);

  let minutes;
  // If the format doesn't include hours, don't subtract hours from minutes
  if (format.indexOf('h') < 0) {
    minutes = Math.floor(totalSeconds / 60);
  } else {
    minutes = Math.floor(totalSeconds / 60) - hours * 60;
  }

  const seconds = Math.floor(totalSeconds) % 60;

  // TODO: Remove leading places if they don't exist.
  return (
    (isNegative ? '-' : '') +
    format
      .replace('hh', leftPadWithZeros(hours, 2))
      .replace('mm', leftPadWithZeros(minutes, 2))
      .replace('ss', leftPadWithZeros(seconds, 2))
  );
};
